import {
  AlertsCommentaryReviewInput,
  AlertsCommentaryReviewResultContent,
} from '@aloft/toolkit-shared';
import { Block, Flex, Typography } from '@aloft/toolkit-sui';

export const AlertsCommentaryReviewResults = ({
  data,
}: {
  data: { input: AlertsCommentaryReviewInput; review: AlertsCommentaryReviewResultContent };
}) => (
  <Flex flexDirection="column" gap="16px">
    {data.review.reviews.map((review, index) => {
      const alert = data.input.alerts[index];
      return (
        <Block
          key={`${review.type}-${index}`}
          padding="16px"
          borderRadius="8px"
          backgroundColor={
            review.verdict === 'satisfactory' ? 'alertSuccessLight' : 'alertErrorLight'
          }
        >
          <Flex flexDirection="column" gap="8px">
            <Typography variant="h4">{review.type}</Typography>
            <Typography variant="h3">
              {review.verdict === 'satisfactory'
                ? 'Satisfactory'
                : `Insufficient: ${review.reason}`}
            </Typography>
            {alert && (
              <>
                <Typography variant="h5">{alert.body}</Typography>
                <Typography variant="body2" color="textTertiary">
                  Tips: {alert.tips}
                </Typography>
                <Typography variant="body1" color="buttonDefault">
                  Commentary: {alert.commentary || 'None'}
                </Typography>
              </>
            )}
            {review.verdict === 'insufficient' && (
              <Block
                marginTop="10px"
                border="1px solid"
                borderColor="graphNeutral"
                padding="10px"
                borderRadius="5px"
              >
                <Typography variant="body2">{review.missing}</Typography>
                <Typography variant="tableH1">{review.suggestedRevision}</Typography>
              </Block>
            )}
          </Flex>
        </Block>
      );
    })}
  </Flex>
);
